<template>
  <svg width="17" height="16" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.03 0C3.912 0 .463 3.112.05 7.2H8.5L6.661 5.366a.798.798 0 0 1 .005-1.127.803.803 0 0 1 1.13-.005l3.207 3.2a.799.799 0 0 1 0 1.132l-3.208 3.2a.803.803 0 0 1-1.13-.004.798.798 0 0 1-.004-1.128L8.501 8.8H.05c.432 4.293 4.2 7.47 8.515 7.182 4.315-.288 7.624-3.938 7.48-8.25C15.9 3.422 12.356 0 8.03 0z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
